export const computeTrend = (points) => {
  if (!points?.length) {
    return { direction: "flat", changePercent: null, label: "Not enough data" };
  }

  const mid = Math.floor(points.length / 2);
  const firstHalf = points.slice(0, mid).reduce((sum, row) => sum + row.value, 0);
  const secondHalf = points.slice(mid).reduce((sum, row) => sum + row.value, 0);

  if (firstHalf === 0 && secondHalf === 0) {
    return { direction: "flat", changePercent: 0, label: "Flat" };
  }

  if (firstHalf === 0) {
    return { direction: "up", changePercent: 100, label: "Up" };
  }

  const changePercent = Math.round(((secondHalf - firstHalf) / firstHalf) * 100);
  let direction = "flat";
  if (changePercent > 5) direction = "up";
  if (changePercent < -5) direction = "down";

  const label =
    direction === "up"
      ? "Trending up"
      : direction === "down"
        ? "Trending down"
        : "Steady";

  return { direction, changePercent, label };
};

export const buildTrendHeadline = (series) => {
  const ranked = [...series]
    .filter((row) => row.total > 0)
    .sort((a, b) => Math.abs(b.trend.changePercent || 0) - Math.abs(a.trend.changePercent || 0));

  const leader = ranked[0];
  if (!leader || leader.trend.changePercent === null) {
    return "Website activity is still building — check back as more monthly data comes in.";
  }

  if (leader.trend.direction === "up") {
    return `${leader.label} is trending up (${leader.trend.changePercent}% in recent months vs earlier months).`;
  }

  if (leader.trend.direction === "down") {
    return `${leader.label} is softer lately (${leader.trend.changePercent}% vs earlier months in this period).`;
  }

  return "Website activity has been fairly steady month to month.";
};

export const sliceWebsiteTrends = (trends, days) => {
  if (!trends?.series?.length) return trends;

  const availableDays = trends.days || trends.dateKeys?.length || 0;
  const sliceDays = Math.min(Math.max(1, days), availableDays);
  if (sliceDays >= availableDays) return trends;

  const series = trends.series.map((row) => {
    const points = row.points.slice(-sliceDays);
    const total = points.reduce((sum, point) => sum + point.value, 0);

    return {
      ...row,
      points,
      total,
      trend: computeTrend(points),
    };
  });

  return {
    ...trends,
    days: sliceDays,
    dateKeys: trends.dateKeys.slice(-sliceDays),
    series,
    headline: buildTrendHeadline(series),
    hasActivity: series.some((row) => row.total > 0),
  };
};
